<template>
  <div class="core-advantage">
    <!-- Banner 图片 -->
    <div v-if="data.bannerImage" class="banner-section">
      <img :src="data.bannerImage" alt="Banner" class="banner-image">
    </div>

    <!-- 底部图片区域 -->
    <div v-if="data.bottomImages && data.bottomImages.length > 0" class="bottom-section">
      <div class="bottom-container">
        <img
          v-for="(img, index) in data.bottomImages"
          :key="index"
          :src="img"
          :alt="`核心优势图片${index + 1}`"
          class="bottom-image"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoreAdvantage',
  props: {
    data: {
      type: Object,
      default: () => ({
        bannerImage: '',
        bottomImages: []
      })
    }
  }
}
</script>

<style scoped>
.core-advantage {
  width: 100%;
}

/* Banner 区域 */
.banner-section {
  width: 100%;
  height: 400px;
  margin-bottom: 0;
}

.banner-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

/* 底部图片区域 */
.bottom-section {
  width: 100%;
  padding: 40px 0;
  background: #fff;
}

.bottom-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.bottom-image {
  max-width: 100%;
  height: auto;
  display: block;
}

/* 移动端 */
@media (max-width: 768px) {
  .banner-section {
    height: 250px;
  }

  .bottom-section {
    padding: 24px 0;
  }

  .bottom-container {
    padding: 0 16px;
    flex-direction: column;
  }

  .bottom-image {
    width: 100%;
  }
}
</style>
